export default __webpack_public_path__ + "static/media/welpentreffen_21.e96fbb4e.jpg";